import React from "react";
import { FiSend } from "react-icons/fi";
import { StyleSheet } from "react-native";
import { Send, SendProps } from "react-native-gifted-chat";
import { FormattedChatMessage } from "../../app/types";
import Spinner from "../common/Spinner";
import LightTheme from "../theme/LightTheme";

const GiftedChatSend = (props: SendProps<FormattedChatMessage>) => {
  const {
    extraData: { isLoading },
    text,
  } = props as unknown as any; // eslint-disable-line @typescript-eslint/no-explicit-any
  const disabled = text.length === 0;
  return (
    <>
      <Send disabled={disabled} {...props} containerStyle={styles.container}>
        {isLoading ? (
          <div className="spinnerContainer">
            <Spinner size={30} />
          </div>
        ) : (
          <div className={`iconContainer ${disabled && "disabled"}`}>
            <FiSend size={20} color="white" />
          </div>
        )}
      </Send>
      <style jsx>{`
        div {
          display: flex;
          background: ${LightTheme.gradientBackground};
          border-radius: 50%;
          height: 30px;
          width: 30px;
        }
        .spinnerContainer {
          justify-content: center;
          align-items: center;
        }
        .iconContainer {
          border-radius: 50%;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 6px 0 0 4px;
        }
        .disabled {
          background: grey;
        }
        img {
          height: 20px;
          width: 20px;
        }
      `}</style>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    height: "100%",
    width: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px",
    marginRight: "10px",
  },
});

export default GiftedChatSend;
